import Menu from '@/services/Menu';
import Vue from 'vue';
import * as types from '../mutation-types';

const getDefaultSelectedItem = () => ({
  id: null,
  title: null,
  options: null,
  populateOptions: null,
  populateQuantity: null,
  basketIndex: null,
});

// initial state
const state = () => ({
  items: [],
  showItemDialog: false,
  selectedItem: { ...getDefaultSelectedItem() },
});

// getters
const getters = {
  selectedOptions(state, getters) {
    return state.selectedItem && state.selectedItem.options.reduce((opts, option) => {
      const optionId = option.id;
      opts[optionId] = state.selectedItem.populateOptions[optionId] ?? getters.selectedOption[optionId];

      return opts;
    }, {});
  },

  selectedOption(state) {
    return state.selectedItem && state.selectedItem.options.reduce((opts, option) => {
      const optionId = option.id;
      const selected = option.items.find((item) => item.selected);
      opts[optionId] = selected ? selected.id : null;

      return opts;
    }, {});
  },

  itemsFlattened(state) {
    return state.items.flatMap((category) => category.sections.flatMap((subcategory) => subcategory.items));
  },
};

// actions
const actions = {
  async getMenu({ commit, dispatch, getters }) {
    const { data } = await Menu.get();
    await commit(types.MENU_SET_ITEMS, data);
    dispatch('refreshBasket');
  },

  selectMenuItem(
    { commit, state, getters },
    {
      id,
      options: populateOptions = {},
      quantity: populateQuantity = 1,
      basketIndex,
    },
  ) {
    const selectedItem = getters.itemsFlattened.find((item) => item.id === id);

    const item = {
      id: selectedItem.id,
      title: selectedItem.title,
      options: selectedItem.options,
      populateOptions,
      populateQuantity,
      basketIndex,
    };

    commit(types.MENU_SELECT_ITEM, item);
  },

  selectOption({ commit }, { id, option }) {
    commit(types.MENU_UPDATE_SELECTED_ITEM_OPTION, { id, option });
  },

  deSelectMenuItem({ commit }) {
    commit(types.MENU_DESELECT_ITEM);
  },
};

// mutations
const mutations = {
  [types.MENU_SET_ITEMS](state, menu) {
    state.items = menu;
  },

  [types.MENU_SELECT_ITEM](state, item) {
    state.selectedItem = item;
    state.showItemDialog = true;
  },

  [types.MENU_DESELECT_ITEM](state) {
    state.showItemDialog = false;
    state.selectedItem = { ...getDefaultSelectedItem() };
  },

  [types.MENU_UPDATE_SELECTED_ITEM_QUANTITY](state, value) {
    if (value < 1) {
      // do something if a basket item
      return;
    }

    Vue.set(state.selectedItem, 'populateQuantity', value);
  },

  [types.MENU_UPDATE_SELECTED_ITEM_OPTION](state, { id, option }) {
    Vue.set(state.selectedItem.populateOptions, id, option);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
